import {
  ArrowRight,
  ArrowUpRight,
  Facebook,
  Instagram,
  Youtube,
} from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LocalizedLink } from "@/components/LocalizedLink";
import { SEO } from "@/components/SEO";
import { ScrollReveal } from "@/components/ScrollReveal";
import { HomeHero } from "@/components/field/HomeHero";
import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  ORGANIZATION_SAME_AS,
  YOUTUBE_URL,
} from "@/lib/brand";
import "@/styles/home-overview.css";

const Index = () => {
  const { t, language } = useLanguage();
  const s = (key: string) => t(`field.home.simple.${key}`);
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Fluxabee",
      url: "https://www.fluxabee.com",
      logo: "https://www.fluxabee.com/favicon.png",
      description: t("field.home.seo.description"),
      email: "info@fluxabee.com",
      telephone: "+48795446752",
      sameAs: ORGANIZATION_SAME_AS,
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Fluxabee",
      url: "https://www.fluxabee.com",
      inLanguage: language,
    },
  ];

  return (
    <main className="field-page field-home" id="main-content">
      <SEO
        titleKey="field.home.seo.title"
        descriptionKey="field.home.seo.description"
        jsonLd={schema}
      />
      <HomeHero />

      <section className="home-mission" id="mission" aria-labelledby="home-mission-title">
        <div className="field-wrap home-mission-inner">
          <ScrollReveal className="home-mission-grid">
            <div>
              <p className="field-label home-mission-label">{s("mission.label")}</p>
              <h2 className="field-title home-mission-title" id="home-mission-title">
                {s("mission.title")}{" "}
                <span>{s("mission.titleAccent")}</span>
              </h2>
            </div>
            <div className="home-mission-copy">
              <p className="home-mission-lead">{s("mission.lead")}</p>
              <p className="home-mission-body">{s("mission.body")}</p>
            </div>
          </ScrollReveal>
          <ScrollReveal className="home-mission-updates">
            <div className="home-mission-next">
              <h3>{s("mission.nextTitle")}</h3>
              <p>{s("mission.nextBody")}</p>
            </div>
            <div className="home-mission-socials">
              <a
                href={YOUTUBE_URL}
                className="field-text-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s("mission.youtube")}
              >
                <Youtube size={18} strokeWidth={1.5} aria-hidden="true" />
                YouTube
                <ArrowUpRight size={16} aria-hidden="true" />
              </a>
              <a
                href={INSTAGRAM_URL}
                className="field-text-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s("mission.instagram")}
              >
                <Instagram size={18} strokeWidth={1.5} aria-hidden="true" />
                Instagram
                <ArrowUpRight size={16} aria-hidden="true" />
              </a>
              <a
                href={FACEBOOK_URL}
                className="field-text-link"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s("mission.facebook")}
              >
                <Facebook size={18} strokeWidth={1.5} aria-hidden="true" />
                Facebook
                <ArrowUpRight size={16} aria-hidden="true" />
              </a>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="home-overview-finish" id="download" aria-labelledby="home-finish-title">
        <ScrollReveal className="field-wrap home-overview-finish-inner">
          <div>
            <h2 className="field-title" id="home-finish-title">{s("finish.title")}</h2>
            <p>{s("finish.body")}</p>
          </div>
          <div className="home-overview-finish-actions">
            <LocalizedLink to="/platform" className="field-button">
              {s("appCta")}
              <ArrowUpRight size={18} aria-hidden="true" />
            </LocalizedLink>
            <LocalizedLink to="/products" className="field-text-link">
              {s("shopCta")}
              <ArrowRight size={18} aria-hidden="true" />
            </LocalizedLink>
          </div>
        </ScrollReveal>
      </section>
    </main>
  );
};

export default Index;
